import React, { memo, useState } from 'react';
// import { Row, Col } from 'react-bootstrap';
import FieldHeader from './FieldHeader';
import FieldBody from './FieldBody';
// import logo from '../../../../../../assets/images/acuitus-ag-logo.png';

const Fields = () => {
    const [searchText, setSearchText] = useState("");

    return <div className={`h-100`}>
        {/* <Row className="coming-soon">
            <Col className="text-center"> <img src={logo} alt="" /><p>Coming Soon...</p></Col>
        </Row> */}
        <FieldHeader searchText={searchText} setSearchText={setSearchText} />
        <FieldBody searchText={searchText} />
    </div>
}

export default memo(Fields);
